import React, { useState, useEffect } from 'react';
import api from "../../utils/axiosInstance";
import {
    FaMapMarkerAlt, FaIdCard, FaIdBadge, FaTruck, FaPhone, FaClock,
    FaEye, FaEdit, FaToggleOn, FaToggleOff, FaTrash, FaCalendarAlt
} from 'react-icons/fa';
import AdminSideMenu from '../../components/AdminSideMenu';
import Select from "react-select";
import { searchStates, getStateName } from '../../utils/stateSearch';

export default function DriversListing() {
    const [drivers, setDrivers] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [search, setSearch] = useState('');
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [identificationNumber, setIdentificationNumber] = useState('');
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [form, setForm] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [totalDrivers, setTotalDrivers] = useState(0);
    const [selectedState, setSelectedState] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [cities, setCities] = useState([]);

    const itemsPerPage = 18;
    const pageCount = Math.ceil(totalDrivers / itemsPerPage);
    useEffect(() => {
        setCurrentPage(1);
    }, [search]);

    const trailerOptions = [
        { value: "Van", label: "Van" },
        { value: "Flatbed", label: "Flatbed" },
        { value: "Reefer", label: "Reefer" },
        { value: "Tanker", label: "Tanker" },
        { value: "Other", label: "Others" },
    ];

    const routeOptions = [
        { value: "OTR", label: "Over the Road" },
        { value: "Regional", label: "Regional" },
        { value: "Local", label: "Local" },
        { value: "All", label: "All Routes" },
    ];

    const endorsementOptions = [
        { value: "Hazmat", label: "Hazmat" },
        { value: "Double", label: "Doubles/Triples" },
        { value: "Tank", label: "Tank" },
        { value: "Hazardous", label: "Hazardous Tanker" },
        { value: "Passenger", label: "Passenger" },
        { value: "None", label: "None of these" },
    ];

    const STATES = [
        { code: 'AL', name: 'Alabama' },
        { code: 'AK', name: 'Alaska' },
        { code: 'AZ', name: 'Arizona' },
        { code: 'AR', name: 'Arkansas' },
        { code: 'CA', name: 'California' },
        { code: 'CO', name: 'Colorado' },
        { code: 'CT', name: 'Connecticut' },
        { code: 'DE', name: 'Delaware' },
        { code: 'FL', name: 'Florida' },
        { code: 'GA', name: 'Georgia' },
        { code: 'HI', name: 'Hawaii' },
        { code: 'ID', name: 'Idaho' },
        { code: 'IL', name: 'Illinois' },
        { code: 'IN', name: 'Indiana' },
        { code: 'IA', name: 'Iowa' },
        { code: 'KS', name: 'Kansas' },
        { code: 'KY', name: 'Kentucky' },
        { code: 'LA', name: 'Louisiana' },
        { code: 'ME', name: 'Maine' },
        { code: 'MD', name: 'Maryland' },
        { code: 'MA', name: 'Massachusetts' },
        { code: 'MI', name: 'Michigan' },
        { code: 'MN', name: 'Minnesota' },
        { code: 'MS', name: 'Mississippi' },
        { code: 'MO', name: 'Missouri' },
        { code: 'MT', name: 'Montana' },
        { code: 'NE', name: 'Nebraska' },
        { code: 'NV', name: 'Nevada' },
        { code: 'NH', name: 'New Hampshire' },
        { code: 'NJ', name: 'New Jersey' },
        { code: 'NM', name: 'New Mexico' },
        { code: 'NY', name: 'New York' },
        { code: 'NC', name: 'North Carolina' },
        { code: 'ND', name: 'North Dakota' },
        { code: 'OH', name: 'Ohio' },
        { code: 'OK', name: 'Oklahoma' },
        { code: 'OR', name: 'Oregon' },
        { code: 'PA', name: 'Pennsylvania' },
        { code: 'RI', name: 'Rhode Island' },
        { code: 'SC', name: 'South Carolina' },
        { code: 'SD', name: 'South Dakota' },
        { code: 'TN', name: 'Tennessee' },
        { code: 'TX', name: 'Texas' },
        { code: 'UT', name: 'Utah' },
        { code: 'VT', name: 'Vermont' },
        { code: 'VA', name: 'Virginia' },
        { code: 'WA', name: 'Washington' },
        { code: 'WV', name: 'West Virginia' },
        { code: 'WI', name: 'Wisconsin' },
        { code: 'WY', name: 'Wyoming' }
    ];

    useEffect(() => {
        setCurrentPage(1);
        fetchDrivers(1);
    }, [search, selectedState, selectedCity]);

    useEffect(() => {
        console.log('Current search term:', search);
        console.log('Filtered drivers count:', filtered.length);
        console.log('Total drivers:', totalDrivers);
    }, [search, filtered, totalDrivers]);

    const fetchDrivers = async (page = 1, limit = 18) => {
        try {
            const res = await api.get('/drivers/paginated', {
                params: {
                    page,
                    limit,
                    searchTerm: search,
                    identificationNumber: identificationNumber,
                    state: selectedState,
                    city: selectedCity, // NEW: Send city to backend
                },
            });

            const driverList = res.data.data || [];

            setDrivers(driverList);
            setFiltered(driverList); // ALWAYS set filtered to the API response

            // Update pagination state
            setCurrentPage(Number(res.data.page) || page);
            setTotalDrivers(res.data.totalCount || 0);

        } catch (err) {
            console.error('Failed to fetch drivers:', err);
            setDrivers([]);
            setFiltered([]);
        }
    };

    // Update cities dropdown when drivers data changes
    useEffect(() => {
        const uniqueCities = extractCities(drivers);
        setCities(uniqueCities);
    }, [drivers]);

    // Extract unique cities from current drivers for dropdown
    const extractCities = (driversList) => {
        const citySet = new Set();
        driversList.forEach(driver => {
            if (driver.city && driver.city.trim() !== '') {
                citySet.add(driver.city);
            }
        });
        return Array.from(citySet).sort();
    };

    const handleToggleActive = async (id, currentStatus) => {
        try {
            await api.put(`/drivers/toggle/${id}`, { isActive: !currentStatus });
            fetchDrivers();
        } catch (err) {
            console.error('Toggle active status failed:', err);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this driver?')) {
            try {
                await api.delete(`/drivers/${id}`);
                fetchDrivers();
            } catch (err) {
                console.error('Delete driver failed:', err);
            }
        }
    };

    const handleEditSubmit = async () => {
        try {
            const { _id, ...dataToUpdate } = form;
            await api.put(`/drivers/${_id}`, dataToUpdate);
            fetchDrivers();
            handleModalClose();
        } catch (err) {
            alert('Update failed. Check console.');
            console.error(err);
        }
    };

    const handleModalOpen = (driver, edit = false) => {
        setSelectedDriver(driver);
        setIsEdit(edit);
        setForm(driver);
    };

    const handleModalClose = () => {
        setSelectedDriver(null);
        setIsEdit(false);
        setForm({});
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const goToPage = (page) => {
        setCurrentPage(page);
        fetchDrivers(page);
    };

    return (
        <div className="flex flex-col min-h-screen">
            <div className="flex flex-1">
                <AdminSideMenu isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
                <div className="flex-1 md:ml-64 min-h-screen pt-16 md:pt-0">
                    <header className="bg-gray-100 pb-4 pt-4">
                        <div className="flex justify-between items-center px-6">
                            <div>
                                <h1 className="text-2xl font-bold text-gray-900">Drivers</h1>
                                <p className="text-gray-600 text-sm">Manage your drivers here</p>
                            </div>
                        </div>
                    </header>

                    {/* Filters */}
                    <div className="space-y-4 my-6 px-6">
                        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                            <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search by Name, Fleety ID, Phone" className="px-4 py-2 rounded-lg border border-gray-300 w-full" />
                        </div>

                        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 max-w-md">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Filter by State</label>
                                <select
                                    value={selectedState}
                                    onChange={(e) => {
                                        setSelectedState(e.target.value);
                                        // Keep the current city selection
                                    }}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                                >
                                    <option value="">All States</option>
                                    {STATES.map(state => (
                                        <option key={state.code} value={state.code}>
                                            {state.name} ({state.code})
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="flex gap-2">
                                <div className="flex-1">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Filter by City</label>
                                    <select
                                        value={selectedCity}
                                        onChange={(e) => setSelectedCity(e.target.value)}
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                                    >
                                        <option value="">All Cities</option>
                                        {cities.length > 0 ? (
                                            cities.map(city => (
                                                <option key={city} value={city}>
                                                    {city}
                                                </option>
                                            ))
                                        ) : (
                                            <option value="" disabled>No cities available</option>
                                        )}
                                    </select>
                                </div>
                                {selectedCity && (
                                    <div className="flex items-end">
                                        <button
                                            onClick={() => setSelectedCity('')}
                                            className="px-3 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 text-sm mb-1"
                                            title="Clear city filter"
                                        >
                                            ✕
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {totalDrivers > 0 && (
                        <div className="mb-4 px-6 text-sm font-semibold text-gray-800">
                            Showing {filtered.length} of {totalDrivers} drivers
                        </div>
                    )}
                    {/* Cards */}
                    <section className="grid grid-cols-1 gap-4 px-6 md:grid-cols-2 lg:grid-cols-3">
                        {filtered.length === 0 ? (
                            <p className="col-span-full text-center text-gray-500">No drivers found</p>
                        ) : filtered.map((d, i) => (
                            <div key={i} className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm">
                                <h3 className="text-lg font-semibold text-gray-900">{d.name}</h3>
                                <p className="text-sm text-gray-500 flex items-center">
                                    <FaMapMarkerAlt className="text-blue-700 mr-1" />
                                    {d.state && d.state.trim() !== '' ? getStateName(d.state) : 'N/A'}
                                </p>
                                <div className="mt-3 text-sm text-gray-700 space-y-1">
                                    <p><FaIdBadge className="inline mr-2 text-blue-600" />Fleety ID: {d.identificationNumber}</p>
                                    <p>
                                        <FaIdCard className="inline mr-2 text-blue-600" />
                                        CDL: {d.cdl && d.cdl.trim() !== '' ? d.cdl : 'N/A'}
                                    </p>

                                    <p>
                                        <FaTruck className="inline mr-2 text-blue-600" />
                                        Trailer:{' '}
                                        {Array.isArray(d.trailer) && d.trailer.some(t => t.trim() !== '')
                                            ? d.trailer.filter(t => t.trim() !== '').join(', ')
                                            : 'N/A'}
                                    </p>

                                    <p>
                                        <FaPhone className="inline mr-2 text-blue-600" />
                                        Phone: {d.phone && d.phone.trim() !== '' ? d.phone : 'N/A'}
                                    </p>

                                    <p>
                                        <FaClock className="inline mr-2 text-blue-600" />
                                        Experience: {d.experience && d.experience.trim() !== '' ? d.experience : 'N/A'}
                                    </p>

                                    <p>
                                        <FaCalendarAlt className="inline mr-2 text-blue-600" />
                                        Date of Join:{" "}
                                        <span className="font-bold">
                                            {(() => {
                                                const date = new Date(d.createdAt);
                                                const mm = String(date.getMonth() + 1).padStart(2, "0");
                                                const dd = String(date.getDate()).padStart(2, "0");
                                                const yyyy = date.getFullYear();
                                                return `${mm}/${dd}/${yyyy}`;
                                            })()}
                                        </span>
                                    </p>
                                    <p>
                                        <strong>Status:</strong>{' '}
                                        <span className={d.isActive ? 'text-green-600 font-semibold' : 'text-blue-600 font-semibold'}>
                                            {d.isActive ? 'Active' : 'Inactive'}
                                        </span>
                                    </p>
                                </div>
                                <div className="mt-4 flex justify-between items-center">
                                    <div>
                                        {d.resume ? (
                                            <a href={`${process.env.REACT_APP_IMAGE_BASE_URL}/${d.resume.replace(/\\/g, '/')}`} target="_blank" rel="noopener noreferrer" className="text-sm text-blue-600 hover:underline">View Resume</a>
                                        ) : (
                                            <span className="text-xs text-gray-400">No Resume</span>
                                        )}
                                    </div>
                                    <div className="flex gap-2">
                                        <button onClick={() => handleModalOpen(d, false)} className="text-blue-500 hover:text-blue-700" title="View"><FaEye /></button>
                                        <button onClick={() => handleModalOpen(d, true)} className="text-yellow-500 hover:text-yellow-700" title="Edit"><FaEdit /></button>
                                        <button onClick={() => handleToggleActive(d._id, d.isActive)} className="text-gray-700 hover:text-black" title="Toggle Status">
                                            {d.isActive ? <FaToggleOn /> : <FaToggleOff />}
                                        </button>
                                        <button onClick={() => handleDelete(d._id)} className="text-blue-600 hover:text-blue-800" title="Delete"><FaTrash /></button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </section>
                    {/* Pagination */}
                    {pageCount > 1 && (
                        <div className="flex justify-center mt-10">
                            <nav className="flex items-center space-x-2 shadow-md px-2 py-2 rounded-lg bg-white">

                                {/* Previous button */}
                                <button
                                    onClick={() => currentPage > 1 && goToPage(currentPage - 1)}
                                    disabled={currentPage === 1}
                                    className={`h-9 w-9 flex items-center justify-center rounded-full transition ${currentPage === 1
                                        ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                                        : "bg-gray-100 text-gray-700 hover:bg-blue-100 hover:text-blue-700"
                                        }`}
                                >
                                    &laquo;
                                </button>

                                {/* First page */}
                                <button
                                    onClick={() => goToPage(1)}
                                    className={`h-9 w-9 rounded-full flex items-center justify-center text-base font-semibold transition ${currentPage === 1
                                        ? "bg-blue-600 text-white shadow-lg border border-blue-600"
                                        : "bg-gray-100 text-gray-900 hover:bg-blue-100 hover:text-blue-700"
                                        }`}
                                >
                                    1
                                </button>

                                {/* Left Ellipsis */}
                                {currentPage > 4 && (
                                    <span className="h-9 w-9 flex items-center justify-center text-gray-500 select-none">
                                        ...
                                    </span>
                                )}

                                {Array.from({ length: pageCount }, (_, i) => i + 1)
                                    .filter(
                                        (page) =>
                                            page !== 1 &&
                                            page !== pageCount &&
                                            page >= Math.max(2, currentPage - 2) &&
                                            page <= Math.min(pageCount - 1, currentPage + 2)
                                    )
                                    .map((page) => (
                                        <button
                                            key={page}
                                            onClick={() => goToPage(page)}
                                            className={`h-9 w-9 rounded-full flex items-center justify-center text-base font-semibold transition ${currentPage === page
                                                ? "bg-blue-600 text-white shadow-lg border border-blue-600"
                                                : "bg-gray-100 text-gray-900 hover:bg-blue-100 hover:text-blue-700"
                                                }`}
                                        >
                                            {page}
                                        </button>
                                    ))}


                                {/* Right Ellipsis */}
                                {currentPage < pageCount - 3 && (
                                    <span className="h-9 w-9 flex items-center justify-center text-gray-500 select-none">
                                        ...
                                    </span>
                                )}

                                {/* Last page */}
                                {pageCount > 1 && (
                                    <button
                                        onClick={() => goToPage(pageCount)}
                                        className={`h-9 w-9 rounded-full flex items-center justify-center text-base font-semibold transition ${currentPage === pageCount
                                            ? "bg-blue-600 text-white shadow-lg border border-blue-600"
                                            : "bg-gray-100 text-gray-900 hover:bg-blue-100 hover:text-blue-700"
                                            }`}
                                    >
                                        {pageCount}
                                    </button>
                                )}

                                {/* Next button */}
                                <button
                                    onClick={() => currentPage < pageCount && goToPage(currentPage + 1)}
                                    disabled={currentPage === pageCount}
                                    className={`h-9 w-9 flex items-center justify-center rounded-full transition ${currentPage === pageCount
                                        ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                                        : "bg-gray-100 text-gray-700 hover:bg-blue-100 hover:text-blue-700"
                                        }`}
                                >
                                    &raquo;
                                </button>
                            </nav>
                        </div>
                    )}

                </div>
            </div>

            {/* VIEW DRIVER MODAL */}
            {selectedDriver && !isEdit && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 overflow-y-auto">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl p-7 relative max-h-[96vh] overflow-y-auto">
                        <button className="absolute top-4 right-6 text-2xl text-gray-500 hover:text-blue-700" onClick={handleModalClose}>
                            <i className="fas fa-times"></i>
                        </button>
                        <div className="flex flex-col items-center mb-6">
                            <h2 className="text-3xl font-bold text-center text-gray-800 mb-1">{selectedDriver.name || '-'}</h2>
                            <div className="flex gap-3 mt-1 flex-wrap items-center">
                                <span className={`px-4 py-1 rounded-full text-xs font-bold shadow ${selectedDriver.isActive ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-600'}`}>
                                    {selectedDriver.isActive ? 'Active' : 'Inactive'}
                                </span>
                                <span className="bg-gray-100 py-1 px-3 rounded-full text-xs text-black">Fleety ID: {selectedDriver.identificationNumber}</span>
                                {selectedDriver.resume &&
                                    <a href={`${process.env.REACT_APP_IMAGE_BASE_URL}/${selectedDriver.resume.replace(/\\/g, '/')}`} target="_blank" rel="noopener noreferrer" className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-medium hover:underline">
                                        View Resume
                                    </a>
                                }
                            </div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-8 gap-y-4 text-base">
                            <div>
                                <div className="font-semibold text-gray-600">Email</div>
                                <div className="font-bold break-all">{selectedDriver.email || <span className="opacity-60">N/A</span>}</div>
                            </div>
                            <div>
                                <div className="font-semibold text-gray-600">Phone</div>
                                <div className="font-bold">{selectedDriver.phone || <span className="opacity-60">N/A</span>}</div>
                            </div>
                            <div>
                                <div className="font-semibold text-gray-600">Job Title</div>
                                <div className="font-bold">{selectedDriver.job || <span className="opacity-60">N/A</span>}</div>
                            </div>
                            <div>
                                <div className="font-semibold text-gray-600">CDL</div>
                                <div className="font-bold">{selectedDriver.cdl || <span className="opacity-60">N/A</span>}</div>
                            </div>
                            <div>
                                <div className="font-semibold text-gray-600">Trailer(s)</div>
                                <div className="font-bold">
                                    {Array.isArray(selectedDriver.trailer) && selectedDriver.trailer.some(t => t.trim() !== '')
                                        ? selectedDriver.trailer.filter(t => t.trim() !== '').join(', ')
                                        : <span className="opacity-60">N/A</span>
                                    }
                                </div>
                            </div>
                            <div>
                                <div className="font-semibold text-gray-600">Endorsements</div>
                                <div className="font-bold">
                                    {Array.isArray(selectedDriver.endorsements) && selectedDriver.endorsements.some(t => t.trim() !== '')
                                        ? selectedDriver.endorsements.filter(t => t.trim() !== '').join(', ')
                                        : <span className="opacity-60">N/A</span>
                                    }
                                </div>
                            </div>
                            <div>
                                <div className="font-semibold text-gray-600">Route(s)</div>
                                <div className="font-bold">
                                    {Array.isArray(selectedDriver.route) && selectedDriver.route.some(t => t.trim() !== '')
                                        ? selectedDriver.route.filter(t => t.trim() !== '').join(', ')
                                        : <span className="opacity-60">N/A</span>
                                    }
                                </div>                            </div>
                            <div>
                                <div className="font-semibold text-gray-600">City</div>
                                <div className="font-bold">{selectedDriver.city || <span className="opacity-60">N/A</span>}</div>
                            </div>
                            <div>
                                <div className="font-semibold text-gray-600">State</div>
                                <div className="font-bold">
                                    {selectedDriver.state
                                        ? `${getStateName(selectedDriver.state)} (${selectedDriver.state})`
                                        : <span className="opacity-60">N/A</span>
                                    }
                                </div>
                            </div>
                            <div>
                                <div className="font-semibold text-gray-600">ZIP Code</div>
                                <div className="font-bold">{selectedDriver.zip || <span className="opacity-60">N/A</span>}</div>
                            </div>
                            <div>
                                <div className="font-semibold text-gray-600">Address</div>
                                <div className="font-bold">{selectedDriver.address || <span className="opacity-60">N/A</span>}</div>
                            </div>
                            <div>
                                <div className="font-semibold text-gray-600">Experience</div>
                                <div className="font-bold">{selectedDriver.experience || <span className="opacity-60">N/A</span>}</div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* EDIT DRIVER MODAL */}
            {selectedDriver && isEdit && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 overflow-y-auto">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6 relative max-h-[90vh] overflow-y-auto">
                        <button className="absolute top-2 right-2 text-gray-500 hover:text-black" onClick={handleModalClose}>✖</button>
                        <h2 className="text-xl font-bold mb-4">Edit Driver</h2>
                        <div className="space-y-3 text-sm">
                            {/* Name */}
                            <div>
                                <label className="block text-gray-700">Name</label>
                                <input
                                    name="name"
                                    value={form.name || ""}
                                    onChange={handleChange}
                                    className="px-3 py-2 border border-gray-300 rounded w-full"
                                />
                            </div>
                            {/* Email */}
                            <div>
                                <label className="block text-gray-700">Email</label>
                                <input
                                    name="email"
                                    value={form.email || ""}
                                    onChange={handleChange}
                                    className="px-3 py-2 border border-gray-300 rounded w-full"
                                />
                            </div>
                            {/* Phone */}
                            <div>
                                <label className="block text-gray-700">Phone</label>
                                <input
                                    name="phone"
                                    value={form.phone || ""}
                                    onChange={handleChange}
                                    className="px-3 py-2 border border-gray-300 rounded w-full"
                                />
                            </div>
                            {/* Job Type - Single Dropdown */}
                            <div>
                                <label className="block text-gray-700">Job Type</label>
                                <select
                                    id="job"
                                    name="job"
                                    required
                                    className="w-full px-4 py-2 border border-gray-300 rounded"
                                    value={form.job || ""}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Job Type</option>
                                    <option value="Company Driver">Company Driver</option>
                                    <option value="Owner Operator">Owner Operator</option>
                                    <option value="Training">Driver Training</option>
                                    <option value="Lease">Lease Purchase</option>
                                </select>
                            </div>
                            {/* CDL - Single Dropdown */}
                            <div>
                                <label className="block text-gray-700">CDL</label>
                                <select
                                    id="cdl"
                                    name="cdl"
                                    required
                                    className="w-full px-4 py-2 border border-gray-300 rounded"
                                    value={form.cdl || ""}
                                    onChange={handleChange}
                                >
                                    <option value="">Select CDL Type</option>
                                    <option value="Class A">Class A</option>
                                    <option value="Class B">Class B</option>
                                    <option value="Class C">Class C</option>
                                    <option value="No CDL">I don't have a CDL</option>
                                </select>
                            </div>
                            {/* City */}
                            <div>
                                <label className="block text-gray-700">City</label>
                                <input
                                    name="city"
                                    value={form.city || ""}
                                    onChange={handleChange}
                                    className="px-3 py-2 border border-gray-300 rounded w-full"
                                />
                            </div>
                            {/* State - Dropdown */}
                            <div>
                                <label className="block text-gray-700">State</label>
                                <select
                                    name="state"
                                    value={form.state || ""}
                                    onChange={handleChange}
                                    className="w-full px-4 py-2 border border-gray-300 rounded"
                                >
                                    <option value="">Select state</option>
                                    {STATES.map(st => (
                                        <option key={st.code} value={st.code}>
                                            {st.name} ({st.code})
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {/* ZIP */}
                            <div>
                                <label className="block text-gray-700">ZIP Code</label>
                                <input
                                    name="zip"
                                    value={form.zip || ""}
                                    onChange={handleChange}
                                    className="px-3 py-2 border border-gray-300 rounded w-full"
                                />
                            </div>
                            {/* Address */}
                            <div>
                                <label className="block text-gray-700">Address</label>
                                <input
                                    name="address"
                                    value={form.address || ""}
                                    onChange={handleChange}
                                    className="px-3 py-2 border border-gray-300 rounded w-full"
                                />
                            </div>
                            {/* Experience - Single Dropdown */}
                            <div>
                                <label className="block text-gray-700">Experience</label>
                                <select
                                    id="experience"
                                    name="experience"
                                    required
                                    className="w-full px-4 py-2 border border-gray-300 rounded"
                                    value={form.experience || ""}
                                    onChange={handleChange}
                                >
                                    <option value="">Select experience</option>
                                    <option value="none">None</option>
                                    <option value="6 months">6 months</option>
                                    <option value="1 year">1 Year</option>
                                    <option value="2 year">2 Year</option>
                                    <option value="3+">3+ Years</option>
                                </select>
                            </div>

                            {/* Trailer - MultiSelect */}
                            <div>
                                <label className="block text-gray-700">Trailer</label>
                                <Select
                                    isMulti
                                    name="trailer"
                                    value={trailerOptions.filter(opt => (form.trailer || []).includes(opt.value))}
                                    onChange={selected =>
                                        setForm(prev => ({
                                            ...prev,
                                            trailer: selected ? selected.map(x => x.value) : []
                                        }))
                                    }
                                    options={trailerOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder="Select Trailer(s)"
                                />
                            </div>
                            {/* Route - MultiSelect */}
                            <div>
                                <label className="block text-gray-700">Route</label>
                                <Select
                                    isMulti
                                    name="route"
                                    value={routeOptions.filter(opt => (form.route || []).includes(opt.value))}
                                    onChange={selected =>
                                        setForm(prev => ({
                                            ...prev,
                                            route: selected ? selected.map(x => x.value) : []
                                        }))
                                    }
                                    options={routeOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder="Select Route(s)"
                                />
                            </div>
                            {/* Endorsements - MultiSelect */}
                            <div>
                                <label className="block text-gray-700">Endorsements</label>
                                <Select
                                    isMulti
                                    name="endorsements"
                                    value={endorsementOptions.filter(opt => (form.endorsements || []).includes(opt.value))}
                                    onChange={selected =>
                                        setForm(prev => ({
                                            ...prev,
                                            endorsements: selected ? selected.map(x => x.value) : []
                                        }))
                                    }
                                    options={endorsementOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder="Select Endorsements"
                                />
                            </div>
                            <div className="pt-4">
                                <button
                                    onClick={handleEditSubmit}
                                    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-black"
                                >
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


        </div>
    );
}
